<template>
  <div>
    <h1 class="font-bold text-xl mt-2 mb-4">Popular Course</h1>
    <div class="grid lg:grid-cols-2 md:grid-cols-2 gap-cols-1 gap-8">
      <b-card
        class="mb-2 border rounded-xl"
        no-body
        v-for="(item, index) in rightbot"
        :key="'item -' + index"
      >
        <div>
          <div class="overflow-hidden hover-rad-tr relative">
            <img
              :src="item.img"
              alt="course-img"
              class="w-full rounded-tl-lg rounded-tr-lg img-zoom card-topimg-h228 object-cover"
            />

            <div class="card-rating1">
              {{ item.ratings }}/5<i class="ml-1 fa fa-star text-warning"></i>
            </div>
            <!-- <a href="#" class="card-bookmark"
            ><feather-icon icon="BookmarkIcon"
          /></a> -->
          </div>
          <b-card-text class="p-6">
            <div class="row">
              <div class="col-6">
                <p class="font-semibold text-xs">
                  {{ item.students }} Students
                </p>
              </div>
              <div class="col-6 text-right">
                <p class="font-semibold text-xs">
                  {{ item.hourtime }} Hour and {{ item.minstime }} mins
                </p>
              </div>
            </div>
            <h4 class="font-bold text-lg sm-fsize18 mt-3 mb-6 ellipsis-2">
              {{ item.name }}
            </h4>
          </b-card-text>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      rightbot: [
        {
          img: require("@/assets/images/courses/1.png"),
          name: "Motion Graphics: A typhography Animation",
          students: "5,178",
          ratings: "2",
          hourtime: "2",
          minstime: "47",
        },
        {
          img: require("@/assets/images/courses/1.png"),
          name: "Motion Graphics: A typhography Animation",
          students: "5,178",
          ratings: "2",
          hourtime: "2",
          minstime: "47",
        },
        {
          img: require("@/assets/images/courses/1.png"),
          name: "Motion Graphics: A typhography Animation",
          students: "5,178",
          ratings: "2",
          hourtime: "2",
          minstime: "47",
        },
      ],
    };
  },
  methods: {
    async GetUSerCourser() {
      const { data } = await this.$store.dispatch(
        "student/getStudentByUserId",
        {
          userId: this.userData._id,
        }
      );
      // console.log(data);
    },
  },
  mounted() {
    this.GetUSerCourser();
  },
  computed: {
    ...mapState("auth", ["userData"]),
    ...mapState("eLearning", { studentLearning: "studentLearning" }),
  },
};
</script>
